import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Restaumatic$dPromotionsEngine$dCart$dCartData from "../Restaumatic.PromotionsEngine.Cart.CartData/index.js";
import * as Restaumatic$dPromotionsEngine$dProductFilter from "../Restaumatic.PromotionsEngine.ProductFilter/index.js";
import * as Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion from "../Restaumatic.PromotionsEngine.Promotions.Types.Promotion/index.js";
const length = /* #__PURE__ */ Data$dFoldable.foldlArray(c => v => 1 + c | 0)(0);
const containInFilter = productItems => productFilter => requiredItems => requiredItems <= length(Data$dArray.filterImpl(
  v => Restaumatic$dPromotionsEngine$dProductFilter.all(Restaumatic$dPromotionsEngine$dProductFilter.inProductSingleFilter(v))(productFilter),
  productItems
));
const filterByProductFilter = productItems => promotion => {
  if (promotion.conditions.tag === "ProductPromotion") { return containInFilter(productItems)(promotion.conditions._1.productFilter)(promotion.conditions._1.numRequiredItems); }
  return true;
};
const shouldIncludePromotion = items => subtotal => promotion => (() => {
  if (promotion.conditions.tag === "CartPromotion") {
    return promotion.conditions._1.tag === "CartValue" || promotion.conditions._1.tag === "FirstOrder" || !(promotion.conditions._1.tag === "Loyalty");
  }
  if (promotion.conditions.tag === "ProductPromotion") { return true; }
  $runtime.fail();
})() && (() => {
  if (promotion.conditions.tag === "CartPromotion") { return promotion.conditions._1.tag === "CartValue" || !(promotion.conditions._1.tag === "FirstOrder"); }
  if (promotion.conditions.tag === "ProductPromotion") { return true; }
  $runtime.fail();
})() && !Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.eqPromotionConditions.eq(promotion.conditions)(Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.$PromotionConditions(
  "CartPromotion",
  Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.Never
)) && (promotion.promotionType.tag === "Standard" || !(promotion.promotionType.tag === "InformationOnly")) && (() => {
  if (promotion.conditions.tag === "CartPromotion") {
    if (promotion.conditions._1.tag === "CartValue") { return subtotal >= promotion.conditions._1._1.minCartValue; }
    return true;
  }
  return true;
})() && filterByProductFilter(items)(promotion);
const filterPromotions = inputCartData => Data$dArray.filter(shouldIncludePromotion(inputCartData.productItems)(Restaumatic$dPromotionsEngine$dCart$dCartData.sum(Data$dFunctor.arrayMap(x => x.productPrice)(inputCartData.productItems))));
export {containInFilter, filterByProductFilter, filterPromotions, length, shouldIncludePromotion};
